import React, { memo } from "react";
import styles from "../ABfooter.scss";
const {
  top_footer,
  container,
  footer_row,
  list_head,
  footer_col,
  category_text,
  list_items,
  item_col,
  dualItems,
  footer_support,
  support_left,
  support_row,
  support_right,
  footer_support_inside,
  social_media,
  social_icon,
  support_col,
  reach_us,
  contact_items,
  social_right,
} = styles;

export default function TopFooterComponent({
  topFooter,
  footerLoginSupport,
  socialItems,
  footerAnalytics = { footerAnalytics },
}) {
  return (
    <div className={top_footer}>
      <div className={container}>
        <FooterHeadingComponent topFooter={topFooter} footerAnalytics={footerAnalytics} />
        <FooterSupportComponent
          footerLoginSupport={footerLoginSupport}
          socialItems={socialItems}
          footerAnalytics={footerAnalytics}
        />
      </div>
    </div>
  );
}

const FooterHeadingComponent = memo(({ topFooter, footerAnalytics }) => {
  const FooterHeading = (
    <div className={footer_row}>
      {topFooter.map((obj, index) => (
        <div key={index} className={footer_col}>
          {obj?.title === undefined ? (
            ""
          ) : (
            <>
              <h5 className={list_head}>
                {obj?.title} {obj?.titleCategory ? `/` : ""}
                {obj?.titleCategory ? <span className={category_text}>{obj?.titleCategory}</span> : ""}
              </h5>
              <ul className={list_items}>
                <FooterLinksComponent dataValue={obj} segment={obj.title} footerAnalytics={footerAnalytics} />
              </ul>
            </>
          )}
          {obj?.dualItems && <DualItemComponent dualItemsData={obj.dualItems} footerAnalytics={footerAnalytics} />}
        </div>
      ))}
    </div>
  );
  return FooterHeading;
});
const DualItemComponent = memo(({ dualItemsData, footerAnalytics }) =>
  dualItemsData?.map((obj1) => (
    <div className={`${item_col} ${dualItems}`} >
      <h5 className={list_head}>{obj1.title}</h5>
      <ul className={list_items}>
        <FooterLinksComponent dataValue={obj1} segment={obj1.title} footerAnalytics={footerAnalytics} />
      </ul>
    </div>
  )),
);

const FooterLinksComponent = memo(({ dataValue, footerAnalytics }) =>
  dataValue?.item?.map((fdata) => {
    const { url, linkText} = fdata;
    return (
      <li>
        {linkText && (
          <a href={url} onClick={() => footerAnalytics({ segment: dataValue.title, lob: linkText })}>
            {linkText}
          </a>
        )}
      </li>
    );
  }),
);

const FooterSupportComponent = memo(({ footerLoginSupport, socialItems, footerAnalytics }) => {
  return (
    <div className={footer_support}>
      <div className={support_left}>
        <div className={support_row}>
          {" "}
          <LoginSupport loginSupportData={footerLoginSupport} footerAnalytics={footerAnalytics} />{" "}
        </div>
      </div>
      <div className={`${support_right} ${social_right}`}>
        <div className={footer_support_inside}>
          <div className={social_media}>
            <div className={social_icon}>
              <h5 className={list_head}>Social Links</h5>
              <ul>
                {" "}
                <SocialLinks socialItems={socialItems} footerAnalytics={footerAnalytics} />{" "}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const SocialLinks = memo(({ socialItems, footerAnalytics }) =>
  socialItems.map((socialLinkItem) => (
    <li>
      <a
        href={socialLinkItem.url}
        target="_blank"
        onClick={() => footerAnalytics({ segment: "social links", lob: socialLinkItem.altText })}
      >
        <img src={socialLinkItem.iconUrl} alt={socialLinkItem.altText} />
      </a>
    </li>
  )),
);
const LoginSupport = memo(({ loginSupportData, footerAnalytics }) =>
  loginSupportData.map((itemTitle) => (
    <div className={support_col}>
      <h5 className={list_head}>{itemTitle.title}</h5>
      <ul className={list_items}>
        {itemTitle?.item?.map((itemList) => { 
          const { url, tabTarget, linkText, actionText, actionType, typeText , iconUrl} = itemList;
          
          return (
            <li className={actionText ? contact_items : ""}>
              {url ? (
                <a
                  href={url}
                  target={tabTarget === "_blank" ? "_blank" : "_self"}
                  onClick={() => footerAnalytics({ segment: itemTitle.title, lob: linkText })}
                >
                  {linkText}
                </a>
              ) : actionType ? (
                <div class={reach_us}>
                  <img src={iconUrl} alt={actionType} />
                  <span>{typeText}</span>:
                  <a
                    href={actionType}
                    target={typeText === "Whatsapp" ? "_" : ""}
                    onClick={() => footerAnalytics({ segment: itemTitle.title, lob: typeText })}
                  >
                    {actionText}
                  </a>
                </div>
              ) : (
                ""
              )}
            </li>
          );
        })}
      </ul>
    </div>
  )),
);
